import { useMediaQuery, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import MapFiler from 'components/MapFilter';
import { CASABLANCA } from 'components/MapFilter/constants';
import ItemResult from 'components/MapFilter/ItemResult';
import InfoItem from 'containers/ServicesPage/Info';
import CustomMap from 'containers/ServicesPage/Map';
import {
  GridContainer,
  ScrollableBox,
  StyledDivider,
} from 'containers/ServicesPage/styles';
import { ItemResultProps, Position } from 'containers/ServicesPage/types';
import {
  mapLocationsToItemResults,
  mapLocationsToMarkers,
} from 'containers/ServicesPage/utils';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getLocationsSelector } from 'store/global/selectors';

const Casablanca: Position = {
  lat: CASABLANCA.lat,
  lng: CASABLANCA.lon,
};

const Body = () => {
  const locations = useSelector(getLocationsSelector);
  const [center, setCenter] = useState(Casablanca);
  const [markers, setMarkers] = useState([]);
  const [itemResults, setItemResults] = useState([]);
  const [selected, setSelected] = useState(null);
  const [selectedItem, setSelectedItem] = useState<ItemResultProps | null>(
    null,
  );

  const findByIndex = (list: any[], value: number) =>
    list.find((item: any) => item.id === value);

  useEffect(() => {
    setMarkers(mapLocationsToMarkers(locations) as any);
    setItemResults(mapLocationsToItemResults(locations) as any);
  }, [locations]);

  useEffect(() => {
    if (selected != null) {
      setSelectedItem(findByIndex(itemResults, selected!) as any);
    } else {
      setSelectedItem(null);
    }
  }, [itemResults, selected]);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <GridContainer container direction={matches ? 'column' : 'row'}>
      <Grid item xs={matches ? 12 : 5}>
        {selected != null ? (
          <>
            {selectedItem && (
              <InfoItem item={selectedItem} close={() => setSelected(null)} />
            )}
          </>
        ) : (
          <Box pl={matches ? 2 : 4.5} pr={matches ? 2 : 0.5}>
            <MapFiler setCenter={setCenter} />
            {matches && (
              <Grid item xs={12}>
                <CustomMap
                  setSelected={setSelected}
                  center={center}
                  markers={markers}
                  selected={selected!}
                />
              </Grid>
            )}
            <StyledDivider />
            {itemResults.length > 0 && (
              <ScrollableBox>
                {itemResults.map((item: any, index: number) => {
                  return (
                    <GaClickHOC
                      category={EVENT_CATEGORIES.SERVICES}
                      label="Détails"
                    >
                      <ItemResult
                        key={index}
                        title={item.title}
                        subTitle={item.subTitle}
                        onClick={() => setSelected(item.id)}
                      />
                    </GaClickHOC>
                  );
                })}
              </ScrollableBox>
            )}
          </Box>
        )}
      </Grid>
      {!matches && (
        <Grid item xs={matches ? 12 : 7}>
          <CustomMap
            setSelected={setSelected}
            center={center}
            markers={markers}
            selected={selected!}
          />
        </Grid>
      )}
    </GridContainer>
  );
};

export default Body;
